const Section = ({ direction = 'col', children, className }) => {
	return <div className={`flex flex-${direction} bg-white shadow-md p-4 ${className}`}>{children}</div>;
};

export default Section;
